export function firstParam<T>(param: T | T[] | null | undefined): T | null {
  if (param === null || param === undefined) return null;
  if (Array.isArray(param)) return param.length > 0 ? param[0] : null;
  return param;
}
